// ======================================================================
// FILE:
// src/modules/service_crm/installed_products/components/InstalledProductFilterBar.js
//
// MODULE: Service CRM
// FEATURE: Installed Product Filter Bar
// ======================================================================

import React, { useState } from "react";

export default function InstalledProductFilterBar({
  filters = {},
  onApply,
}) {

  // -------------------------------------------------------------------
  // LOCAL STATE
  // -------------------------------------------------------------------
  const [q, setQ] = useState(filters.q || "");

  const [state, setState] = useState(
    filters.state || ""
  );

  const [city, setCity] = useState(
    filters.city || ""
  );

  const [commissioningStatus, setCommissioningStatus] =
    useState(
      filters.commissioning_status || ""
    );

  // -------------------------------------------------------------------
  // APPLY FILTERS
  // -------------------------------------------------------------------
  const applyFilters = () => {

    onApply({
      q,
      state,
      city,
      commissioning_status:
        commissioningStatus,
    });
  };

  // -------------------------------------------------------------------
  // CLEAR FILTERS
  // -------------------------------------------------------------------
  const clearFilters = () => {

    setQ("");

    setState("");

    setCity("");

    setCommissioningStatus("");

    onApply({});
  };

  // -------------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------------
  return (

    <div
      style={{
        background: "#fff",

        borderRadius: 14,

        padding: 18,

        marginBottom: 20,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >

      {/* HEADER */}
      <div
        style={{
          fontSize: 16,

          fontWeight: 700,

          marginBottom: 16,

          color: "#212529",
        }}
      >
        Search & Filters
      </div>

      {/* FILTER GRID */}
      <div
        style={{
          display: "grid",

          gridTemplateColumns:
            "repeat(auto-fit, minmax(220px, 1fr))",

          gap: 14,
        }}
      >

        {/* SEARCH */}
        <div>

          <label
            style={{
              fontSize: 13,

              fontWeight: 600,

              marginBottom: 6,

              display: "block",
            }}
          >
            Search
          </label>

          <input
            type="text"

            className="form-control"

            placeholder="Instance / Customer / Invoice"

            value={q}

            onChange={(e) =>
              setQ(e.target.value)
            }
          />

        </div>

        {/* STATE */}
        <div>

          <label
            style={{
              fontSize: 13,

              fontWeight: 600,

              marginBottom: 6,

              display: "block",
            }}
          >
            State
          </label>

          <input
            type="text"

            className="form-control"

            placeholder="Enter State"

            value={state}

            onChange={(e) =>
              setState(e.target.value)
            }
          />

        </div>

        {/* CITY */}
        <div>

          <label
            style={{
              fontSize: 13,

              fontWeight: 600,

              marginBottom: 6,

              display: "block",
            }}
          >
            City
          </label>

          <input
            type="text"

            className="form-control"

            placeholder="Enter City"

            value={city}

            onChange={(e) =>
              setCity(e.target.value)
            }
          />

        </div>

        {/* COMMISSIONING STATUS */}
        <div>

          <label
            style={{
              fontSize: 13,

              fontWeight: 600,

              marginBottom: 6,

              display: "block",
            }}
          >
            Commissioning Status
          </label>

          <select
            className="form-select"

            value={commissioningStatus}

            onChange={(e) =>
              setCommissioningStatus(
                e.target.value
              )
            }
          >

            <option value="">
              All
            </option>

            <option value="Pending">
              Pending
            </option>

            <option value="Commissioned">
              Commissioned
            </option>

            <option value="Rejected">
              Rejected
            </option>

          </select>

        </div>

      </div>

      {/* ACTIONS */}
      <div
        style={{
          display: "flex",

          justifyContent: "flex-end",

          gap: 10,

          marginTop: 18,
        }}
      >

        {/* CLEAR */}
        <button
          type="button"

          className="btn btn-light"

          onClick={clearFilters}
        >
          Clear
        </button>

        {/* APPLY */}
        <button
          type="button"

          className="btn btn-primary"

          onClick={applyFilters}
        >
          Apply Filters
        </button>

      </div>

    </div>
  );
}